import objectToOption from "./objectToOption";

/**
 * Prefetch pointer options in pages. Returns a cancel() that stops
 * pagination and aborts the active find — required when the pointer
 * unmounts (e.g. report change without employee filter).
 */
function GetOption(
  collection,
  word,
  indexes,
  find,
  where,
  callback,
  keys,
  sort,
  include,
) {
  const query = {
    limit: 1000,
    where: { ...(where || {}) },
    keys: [...(keys || []), ...(indexes || [])],
    include: include,
  };
  if (sort) query.sort = sort;
  if (word && indexes?.length > 0) {
    query.where.$or = indexes.map((index) => ({
      [index]: { $regex: word, $options: "i" },
    }));
  }

  let cancelled = false;
  let timeoutId = null;

  const cancel = () => {
    cancelled = true;
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    try {
      find?.abort?.();
    } catch (_) {
      /* ignore */
    }
  };

  timeoutId = setTimeout(async () => {
    let skip = 0;
    let allOptions = [];

    try {
      while (!cancelled) {
        const chunk = await find.execute(collection, {
          ...query,
          skip,
        });

        if (cancelled) break;

        if (!chunk || chunk.length === 0) {
          callback(allOptions);
          break;
        }

        const currentOptions = chunk.map((obj) =>
          objectToOption(obj, indexes, collection),
        );

        allOptions = [...allOptions, ...currentOptions];

        const sorted = sort
          ? allOptions
          : [...allOptions].sort((a, b) => a.label.localeCompare(b.label));

        if (!cancelled) callback(sorted);

        if (chunk.length < query.limit) break;
        skip += query.limit;
      }
    } catch (err) {
      if (cancelled || err?.name === "AbortError") return;
      console.error("Error fetching data:", err);
      if (!cancelled) callback([]);
    }
  }, 500);

  // Returning cancel also makes `new GetOption(...)` yield cancel (constructor return).
  return cancel;
}

export default GetOption;
